import { isNull } from "./helpers/object-util.js";
import { isNumber } from "@foretagsplatsen/core-helpers/number";
import numbroWrapper from "./numbroWrapper.js";

/**
 * Wrap numbro constructor so it accepts non-number values as first argument.
 *
 * For some reason, our codebase expects numbro to happily format non-number
 * objects such as "-" and null. Numbro v2 has stopped doing that and is now
 * throwing errors (which seems a reasonable choice). For these special cases,
 * this code now returns a numbro-like object.
 *
 * The return value is always a string, whether or not numbro can format the
 * argument.
 *
 * If the argument is null or undefined, use an empty string. `null` and
 * `undefined` cannot be converted to strings.
 */
const numbroWithFailsafe = (value) => {
	if (!isNumber(value)) {
		const result = isNull(value) ? "" : `${value}`;

		return {
			formatCurrency: () => result,
			format: () => result,
		};
	}

	return numbroWrapper(value);
};

export default numbroWithFailsafe;
